export default __webpack_public_path__ + "static/media/dashboard.05981629.png";